"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const immutable_1 = require("immutable");
const currency_symbol_map_1 = __importDefault(require("currency-symbol-map"));
const Select_1 = __importDefault(require("@mui/material/Select"));
const MenuItem_1 = __importDefault(require("@mui/material/MenuItem"));
const MenuList_1 = __importDefault(require("@mui/material/MenuList"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const mui_1 = require("tss-react/mui");
const accounts_1 = require("companion-app-components/flux/accounts");
const budgetsSelectors = __importStar(require("companion-app-components/flux/budgets/budgetsSelectors"));
const core_1 = require("companion-app-components/utils/core");
const budget_items_1 = require("companion-app-components/flux/budget-items");
const selectors_1 = require("data/datasetSharing/selectors");
const budgets_svg_1 = __importDefault(require("assets/zero-state-images/budgets.svg"));
const QProgressBar_1 = __importDefault(require("components/QProgressBar/QProgressBar"));
const useQCurrency_1 = __importDefault(require("components/QCurrency/useQCurrency"));
const UIState_1 = __importDefault(require("components/UIState"));
const LoadingView_1 = __importDefault(require("components/LoadingView"));
const ZeroStateView_1 = __importDefault(require("components/ZeroStateView"));
const helpers_1 = require("containers/OverviewPage/components/helpers");
const utils_1 = require("containers/BudgetsV2/utils");
const compose_1 = __importDefault(require("utils/compose"));
const styles_1 = __importDefault(require("./styles"));
const useStyles = (0, mui_1.makeStyles)()(styles_1.default);
const BudgetOverview = (props) => {
    const { currencies, budgets, budget, budgetChangeHandler, sharedPreferences } = props;
    const { classes, theme } = useStyles();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const { formatAmount } = (0, useQCurrency_1.default)();
    const noOp = () => { };
    const clickBudgetCardTracker = () => {
        const detailsToTrack = (0, utils_1.extractDetailsForTracker)(sharedPreferences);
        core_1.tracker.track(core_1.tracker.events.clickBudgetCard, detailsToTrack);
    };
    const navigateToBudgetsPage = () => {
        clickBudgetCardTracker();
        navigate('/budgets?ref=dashboard');
    };
    const budgetTreeNodes = (0, react_redux_1.useSelector)((state) => budgetsSelectors.getBudgetTreeNodes(state, {
        budget,
        startDate: props.uiState.startDate,
        endDate: props.uiState.endDate,
    }));
    const hasReportableAccounts = (0, react_redux_1.useSelector)((state) => accounts_1.accountsSelectors.getHasReportableAccounts(state));
    const loadPending = (0, react_redux_1.useSelector)((state) => budgetsSelectors.getLoadPending(state) || budget_items_1.budgetItemsSelectors.getLoadPending(state));
    const isLoading = (0, react_redux_1.useSelector)((state) => budgetsSelectors.getIsLoading(state) || budget_items_1.budgetItemsSelectors.getIsLoading(state));
    const isEmpty = !budgets || !budgets.size;
    const showCents = budget && budget.showCents;
    const isCurrentDatasetOwner = (0, react_redux_1.useSelector)((state) => (0, selectors_1.getIsCurrentDatasetOwner)(state));
    const view = (0, helpers_1.computeViewState)(() => loadPending && isLoading, () => isEmpty, hasReportableAccounts);
    // todo: after fixing render issues (props always invalid and always calling render), remove or move to trace
    // log.debug('TopMovers.render...', props);
    return (<div className={classes.root} role="presentation" onClick={view === 'main' ? navigateToBudgetsPage : noOp} onKeyPress={view === 'main' ? navigateToBudgetsPage : noOp}>
      {view === helpers_1.ViewStateEnum.LOADING &&
            <LoadingView_1.default id="budget-overview-loading"/>}

      {view === helpers_1.ViewStateEnum.LOAD_PENDING &&
            <ZeroStateView_1.default style={{ margin: 40 }} primary="No Data" icon={budgets_svg_1.default} secondary="We can't fetch your data from the server. Please try to refresh the page." size="small" id="budget-overview-pending"/>}

      {view === helpers_1.ViewStateEnum.ZERO &&
            <ZeroStateView_1.default icon={budgets_svg_1.default} secondary={['Sync your financial institutions to ', <br key="br"/>, 'see your budgets']} size="small" id="budget-overview-zero"/>}

      {view === helpers_1.ViewStateEnum.EMPTY &&
            <ZeroStateView_1.default icon={budgets_svg_1.default} secondary={isCurrentDatasetOwner ?
                    "It looks like you don't have a budget set up. To see your budget on the web, set up a budget on Quicken Mac or Quicken Windows and perform a one step update." :
                    'It looks like you don’t have a budget set up.'} size="small" id="budget-overview-empty"/>}

      {view === helpers_1.ViewStateEnum.MAIN &&
            <div className={budgetTreeNodes.size < 2 ? classes.budgetContainerSparse : classes.budgetContainer} role="presentation" id="budget-overview-main">
        {budgets && budgets.size > 1 &&
                    <Select_1.default id="budget-overview-select" className={classes.select} value={budget ? `${budget.id}` : ''} onChange={budgetChangeHandler} onClick={(event) => { event.stopPropagation(); }} onKeyPress={(event) => { event.stopPropagation(); }}>
          {budgets.valueSeq().map((theBudget, index) => (<MenuItem_1.default id={index} value={theBudget.id} key={theBudget.id}>
              {theBudget.name}
              {currencies && currencies.size > 1 && theBudget.currency &&
                                ` (${(0, currency_symbol_map_1.default)(theBudget.currency)})`}
            </MenuItem_1.default>))}
        </Select_1.default>}
        {budgets && budgets.size === 1 &&
                    <MenuList_1.default style={{ paddingTop: 0 }}>
          <MenuItem_1.default style={{ justifyContent: 'center' }} className={budgetTreeNodes.size > 2 ? classes.budgetTitleDense : classes.budgetTitle} value={budget.id} onClick={(event) => {
                            event.stopPropagation();
                            clickBudgetCardTracker();
                            navigate('/budgets');
                        }}>
            {budget.name}
            {currencies && currencies.size > 1 && budget.currency &&
                            ` (${(0, currency_symbol_map_1.default)(budget.currency)})`}
          </MenuItem_1.default>
        </MenuList_1.default>}

        {budgetTreeNodes && budgetTreeNodes.map((node, index) => {
                    const { displayLabel } = node;
                    const isIncome = node.negate > 0;
                    const actualAmount = !Number.isNaN(node.actualAmount) ? node.actualAmount * node.negate : undefined;
                    const targetAmount = !Number.isNaN(node.targetAmount) ? node.targetAmount * node.negate : undefined;
                    const rolloverAmount = !Number.isNaN(node.rolloverAmount) && !Number.isNaN(node.negate) ? node.rolloverAmount * node.negate : 0;
                    const targetTotalAmount = !Number.isNaN(targetAmount) ? (targetAmount || 0) + rolloverAmount : undefined;
                    const amountLeft = !Number.isNaN(targetTotalAmount) && !Number.isNaN(actualAmount) ? (targetTotalAmount || 0) - (actualAmount || 0) : undefined;
                    const { currency } = budget;
                    if (index > 1)
                        return (null);
                    return (<div className={budgetTreeNodes.size > 2 ? classes.categoryGroupDense : classes.categoryGroup} key={node.key} role="presentation" onClick={(event) => {
                            event.stopPropagation();
                            clickBudgetCardTracker();
                            navigate(`/budgets?displayBudget=${budget.id}&displayNode=${node.key}&ref=dashboard`);
                        }}>
              <Typography_1.default color="inherit" variant="body2" className={classes.subtitles}>
                {displayLabel}
              </Typography_1.default>
              <div className={classes.annotationsWrap}>
                {!Number.isNaN(actualAmount) &&
                            <Typography_1.default variant="body2" className={classes.annotations}>
                  {`${formatAmount(actualAmount, currency, !showCents)} of ${formatAmount(targetAmount, currency, !showCents)}`}
                </Typography_1.default>}
                {!Number.isNaN(rolloverAmount) && rolloverAmount !== 0 &&
                            <Typography_1.default variant="body2" className={classes.annotations}>
                  {`${rolloverAmount >= 0 ? '+' : '-'} ${formatAmount(Math.abs(rolloverAmount), currency, !showCents)} (rollover)`}
                </Typography_1.default>}
                <Typography_1.default variant="body2" className={classes.annotations}>
                  {!Number.isNaN(amountLeft) && (amountLeft || 0) * (targetAmount || +1) < 0 ?
                            `${formatAmount(Math.abs(amountLeft || 0), budget.currency, !showCents)} Over` :
                            `${formatAmount(Math.abs(amountLeft || 0), budget.currency, !showCents)} Left`}
                </Typography_1.default>
              </div>
              <QProgressBar_1.default height={9} value={!Number.isNaN(actualAmount) ? actualAmount : null} total={!Number.isNaN(targetAmount) ? targetAmount : null} color={!Number.isNaN(amountLeft) && ((isIncome && (targetAmount || 0) < 0 && (amountLeft || 0) > 0) || (!isIncome && (targetAmount || 0) > 0 && (amountLeft || 0) < 0)) ? theme.palette.red2 : theme.palette.green2} textColor="white" backgroundColor="#EFEFEF" noRoundCorners label=""/>
            </div>);
                })}
        {budgetTreeNodes.size > 2 &&
                    <react_router_dom_1.Link to="/budgets?ref=dashboard" className={classes.moreButton}>More</react_router_dom_1.Link>}
      </div>}
    </div>);
};
const BudgetOverviewUIState = (0, immutable_1.Record)({
    startDate: null,
    endDate: null,
});
const uiStateConfig = {
    name: (props) => `BudgetOverview:${props.budget ? props.budget.id : 'noid'}`,
    state: () => {
        const dateNow = new Date();
        const startDate = new Date(dateNow.getFullYear(), dateNow.getMonth(), 1);
        const endDate = new Date(dateNow.getFullYear(), dateNow.getMonth() + 1, 0);
        return new BudgetOverviewUIState({
            startDate,
            endDate,
        });
    },
    persist: true,
};
exports.default = (0, compose_1.default)((0, UIState_1.default)(uiStateConfig))(BudgetOverview);
